import React from "react";
import ReactDOM from "react-dom";
import { Catalog, pageLoader } from "catalog";

// Fix next link errors in Catalog
// Clicking links will still throw!
import { createRouter } from "next/router";
createRouter("/");

// NOTE: dynamic imports currently get messed up by the next/babel preset in .baberc, so don't use pageLoader(() => import('...')) for now!

const pages = [
  {
    path: "/",
    title: "Introduction",
    content: require("../README.md")
  },
  {
    title: "Materials",
    pages: [
      {
        path: "/theme/color",
        title: "Color",
        content: require("../src/theme/colors.docs.tsx")
      },
      {
        path: "/theme/icon",
        title: "Icons",
        content: require("../src/theme/icons.docs.tsx")
      },
      {
        path: "/theme/typefaces",
        title: "Typeface",
        content: require("../src/theme/typefaces.docs.tsx")
      },
      {
        path: "/theme/text",
        title: "Text",
        content: require("../src/theme/text.docs.tsx")
      },
      {
        path: "/theme/layout",
        title: "Layout",
        content: require("../src/theme/layout.docs.tsx")
      }
    ]
  },
  {
    title: "Components",
    pages: [
      {
        path: "/components/logo",
        title: "Logo",
        content: require("../src/components/Logo.docs.tsx")
      },
      {
        path: "/components/loader",
        title: "Loader",
        content: require("../src/components/Loader.docs.tsx")
      },
      {
        path: "/components/alerts",
        title: "Alerts",
        content: require("../src/components/Alerts.docs.tsx")
      },
      {
        path: "/components/generic-page",
        title: "Generic Page",
        content: require("../src/components/GenericPage.docs.tsx")
      },
      {
        path: "/components/cards",
        title: "Cards",
        content: require("../src/components/Cards.docs.tsx")
      },
      {
        path: "/components/modals",
        title: "Modals",
        content: require("../src/components/Modals.docs.tsx")
      },
      {
        path: "/components/controls",
        title: "Controls",
        content: require("../src/components/Controls.docs.tsx")
      },
      {
        path: "/components/header",
        title: "Header",
        content: require("../src/components/Header.docs.tsx")
      },
      {
        path: "/components/search",
        title: "Search",
        content: require("../src/search/Search.docs.tsx")
      },
      {
        path: "/components/tag",
        title: "Tag",
        content: require("../src/components/Tag.docs.tsx")
      },
      {
        path: "/components/tag-list",
        title: "Tag List",
        content: require("../src/components/TagList.docs.tsx")
      },
      {
        path: "/components/accordion",
        title: "Accordion",
        content: require("../src/components/Accordion.docs.tsx")
      },
      {
        path: "/components/search-results-grid",
        title: "Search Results Grid",
        content: require("../src/components/SearchResultsGrid.docs.tsx")
      }
    ]
  }
];

ReactDOM.render(
  <Catalog
    title="STIP Frontend App"
    logoSrc="/logo/logo-blue.svg"
    theme={{
      background: "#f9f9f9",
      brandColor: "#4C4C4C",
      linkColor: "#0070bc",
      pageHeadingBackground: "#0070bc",
      pageHeadingTextColor: "#ffffff",
      sidebarColorHeading: "#0070bc",
      sidebarColorText: "#777",
      sidebarColorTextActive: "#0070bc"
    }}
    pages={pages}
  />,
  document.getElementById("catalog")
);



// WEBPACK FOOTER //
// ./docs/index.js